import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.pug',
  styleUrls: ['./alert-message.component.scss'],
  standalone: false
})
export class AlertMessageComponent implements OnInit {

  @Input() message: any;
  constructor() { }

  ngOnInit(): void {
  }

}
